import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './sass/style.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);